import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { SectionHeadline } from '@/components/SectionHeadline';
import { FAQs } from '@/components/seo/FAQs';
import { Button, Text } from '@mallpay/orbis';
import { Link } from '@/components/links';
import { Trans, useTranslation } from 'react-i18next';
import { LINKS } from '@/constants/links';
import { FaqIntro } from '@/sections/FaqIntro';
import MoreInfo from '@/sections/revolvingLoan/MoreInfo';
export const FAQsSection: React.FC = () => {
  const $ = _c(84);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["core", "revolvingLoan", "eshops", "testimonials"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("revolvingLoan:faq.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline variant="default" anchorKey="revolvingLoan.faq.title" id="faq">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("revolvingLoan:faq.subtitle");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Text as="p" className="text-center">{t3}</Text>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="flex flex-col gap-4">{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("revolvingLoan:faq.items.1.question");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      link1: <Link analyticsParam="pricingLink" testId="pricingLink" to={LINKS().pricing} />
    };
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = <Trans t={t} i18nKey="revolvingLoan:faq.items.1.answer" components={t7} />;
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = {
      question: t6,
      answer: t8
    };
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("revolvingLoan:faq.items.2.question");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("revolvingLoan:faq.items.2.answer");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11) {
    t12 = {
      question: t10,
      answer: t11
    };
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t) {
    t13 = t("revolvingLoan:faq.items.3.question");
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t("revolvingLoan:faq.items.3.answer");
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = {
      question: t13,
      answer: t14
    };
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t("revolvingLoan:faq.items.4.question");
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t) {
    t17 = t("revolvingLoan:faq.items.4.answer");
    $[36] = t;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t16 || $[39] !== t17) {
    t18 = {
      question: t16,
      answer: t17
    };
    $[38] = t16;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t) {
    t19 = t("revolvingLoan:faq.items.5.question");
    $[41] = t;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t) {
    t20 = t("revolvingLoan:faq.items.5.answer");
    $[43] = t;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t19 || $[46] !== t20) {
    t21 = {
      question: t19,
      answer: t20
    };
    $[45] = t19;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t) {
    t22 = t("revolvingLoan:faq.items.6.question");
    $[48] = t;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== t) {
    t23 = t("revolvingLoan:faq.items.6.answer");
    $[50] = t;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== t22 || $[53] !== t23) {
    t24 = {
      question: t22,
      answer: t23
    };
    $[52] = t22;
    $[53] = t23;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  let t25;
  if ($[55] !== t12 || $[56] !== t15 || $[57] !== t18 || $[58] !== t21 || $[59] !== t24 || $[60] !== t9) {
    t25 = <FAQs hideButton={true} className="mx-auto max-w-192 px-4" bgColor="bg-white" data={[t9, t12, t15, t18, t21, t24]} />;
    $[55] = t12;
    $[56] = t15;
    $[57] = t18;
    $[58] = t21;
    $[59] = t24;
    $[60] = t9;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = LINKS();
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  const t27 = t26.faq;
  let t28;
  if ($[63] !== t) {
    t28 = t("revolvingLoan:faq.cta");
    $[63] = t;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  let t29;
  if ($[65] !== t28) {
    t29 = <Button variant="secondary" to={t27} size="lg" analyticsParam="maxiOtherFaqs" testId="maxiOtherFaqs" className="mx-auto">{t28}</Button>;
    $[65] = t28;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  let t30;
  if ($[67] !== t) {
    t30 = t("revolvingLoan:upsell.title");
    $[67] = t;
    $[68] = t30;
  } else {
    t30 = $[68];
  }
  let t31;
  if ($[69] !== t) {
    t31 = t("revolvingLoan:upsell.subtitle");
    $[69] = t;
    $[70] = t31;
  } else {
    t31 = $[70];
  }
  let t32;
  if ($[71] !== t) {
    t32 = t("revolvingLoan:upsell.cta");
    $[71] = t;
    $[72] = t32;
  } else {
    t32 = $[72];
  }
  let t33;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = LINKS();
    $[73] = t33;
  } else {
    t33 = $[73];
  }
  let t34;
  if ($[74] !== t30 || $[75] !== t31 || $[76] !== t32) {
    t34 = <FaqIntro title={t30} text={t31} cta={t32} link={t33.registration} />;
    $[74] = t30;
    $[75] = t31;
    $[76] = t32;
    $[77] = t34;
  } else {
    t34 = $[77];
  }
  let t35;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <MoreInfo />;
    $[78] = t35;
  } else {
    t35 = $[78];
  }
  let t36;
  if ($[79] !== t25 || $[80] !== t29 || $[81] !== t34 || $[82] !== t5) {
    t36 = <div className="flex flex-col gap-16">{t5}{t25}{t29}{t34}{t35}</div>;
    $[79] = t25;
    $[80] = t29;
    $[81] = t34;
    $[82] = t5;
    $[83] = t36;
  } else {
    t36 = $[83];
  }
  return t36;
};